import { connect } from 'react-redux';
import React, { useState } from 'react';
import { Divider, Typography } from 'antd';
import { map } from 'underscore';
import {
    rowTypes,
    SettingsFooter,
} from '../../modules/setting/components/footer';
import { Link } from 'app/shared/link/link';
import classNames from 'classnames';
import { isExternalLink } from '../../functions/isExternalLink';
import { Modal } from '../../shared/modal/modal';
import {
    change_app_setting_content,
    fetchFrontOptions,
} from '../../modules/setting/actions/previewSideBar';
import { setting } from '../../reducers/appReducer';
import { LendingActions } from '../../modules/lending/components/actions';
import { CustomModal } from 'app/shared/customModal/customModal';

const Footer = ({
    content,
    onSave: onSettingSave,
    setSettings,
    showEdit,
    user,
}) => {
    const { footer } = content || {};
    const [visible, setVisible] = useState(false);
    function onCancel() {
        setVisible(false);
    }

    function onPlus() {
        setVisible(true);
    }

    function onSave() {
        onSettingSave(content);
    }

    function onDiscard() {
        setSettings({
            ...content,
            footer: JSON.parse(JSON.stringify(setting.content?.footer || {})),
        });
    }

    return (
        <>
            <div className={'footer-custom-modal'}>
                <CustomModal
                    title={'Настройки подвала'}
                    open={visible}
                    onCancel={onCancel}
                >
                    <SettingsFooter />
                </CustomModal>
            </div>
            <footer className={'footer'}>
                {user?.isAdmin ? (
                    <div className={'footer__header mb-3'}>
                        <LendingActions
                            onEdit={onPlus}
                            onDiscard={onDiscard}
                            onSave={onSave}
                        />
                    </div>
                ) : null}
                <div className={'footer__content'}>
                    <div className={'footer__columns'}>
                        {map(footer?.columns, (column) => {
                            return (
                                <div
                                    className={classNames('footer__column', {
                                        footer__column_equal:
                                            footer.equalColumnWidth,
                                    })}
                                    key={column.id}
                                >
                                    <div className={'footer__header'}>
                                        {column.header}
                                    </div>
                                    {map(column.rows, (row) => {
                                        return <Row key={row.id} row={row} />;
                                    })}
                                </div>
                            );
                        })}
                    </div>
                    <Divider />
                    <Typography.Link
                        rel={'noopener noreferrer'}
                        target={'_blank'}
                        href={'https://mypoint.online/'}
                        className={'footer__copyright'}
                    >
                        © Работает на MyPoint
                    </Typography.Link>
                </div>
            </footer>
        </>
    );
};

const Row = ({ row }) => {
    const { value, type, link, imgs } = row;
    switch (type) {
        case rowTypes.text:
            return (
                <LinkParser link={link}>
                    <div>{value}</div>
                </LinkParser>
            );
        case rowTypes.imgs:
            return (
                <div className={'footer__imgs'}>
                    {map(imgs, ({ width, height, value, link, id }) => (
                        <LinkParser key={id} link={link}>
                            <img
                                width={width}
                                height={height}
                                className={'footer__img'}
                                alt=""
                                src={value}
                            />
                        </LinkParser>
                    ))}
                </div>
            );
        default:
            return null;
    }
};

const LinkParser = ({ link, children }) => {
    if (!link) return children;
    return isExternalLink(link) ? (
        <ExternalLink link={link}>{children}</ExternalLink>
    ) : (
        <Link to={link}>{children}</Link>
    );
};

const ExternalLink = ({ link, children }) => {
    const props = link?.startsWith('tel:')
        ? {}
        : {
              rel: 'noopener noreferrer',
              target: '_blank',
          };
    return (
        <Typography.Link {...props} href={link}>
            {children}
        </Typography.Link>
    );
};

export const ConnectedFooter = connect(
    (state) => {
        return {
            user: state.authState.user,
            content: state.appState.setting.content,
        };
    },
    (dispatch) => {
        return {
            setSettings: (value) =>
                dispatch({ type: change_app_setting_content, data: value }),
            onSave: (settings) =>
                dispatch(
                    fetchFrontOptions({
                        name: 'content',
                        data: settings,
                    })
                ),
        };
    }
)(Footer);
